module.exports = __webpack_public_path__ + "img/cart-line-large.5255953.svg";